import { useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import Network from '../lib/network';
import { receiveEntity, receiveEntities } from '../actions/entities';
import { getLocalItem, setLocalItem } from '../lib/local_storage';
import { defaultMerchant } from '../constants/SiteVariables';

const api = Network();

function useBootstrapper(publicKey, charges) {
  const dispatch = useDispatch();
  const merchant = useSelector(state => state.entities.get('merchant').last());
  const approvedTerms = useSelector(state => state.entities.get('approved_term'));
  const persisted = getLocalItem('prequalification');
  const defaultMerchantPublicKey = defaultMerchant();

  if (!publicKey && persisted) {
    publicKey = persisted.public_key;
    charges = persisted.charges;
  } else if (!publicKey) {
    publicKey = defaultMerchantPublicKey;
  }

  useEffect(() => {
    if (!merchant || approvedTerms.length < 1 || (persisted && charges !== persisted.charges)) {
      api.post({
        resource: 'ecomm/marketing'
      }, {
        public_key: publicKey,
        charges: charges,
        enhanced: true
      })
      .then(res => {
        dispatch(receiveEntity({
          data: {
            id: res.merchant.id,
            type: 'merchant',
            attributes: res.merchant
          }
        }));

        dispatch(receiveEntities({
          data: res.approved_terms.map((t, i) => ({
            id: i,
            type: 'approved_term',
            attributes: t
          }))
        }));

        return res;
      })
      .then(res => {
        setLocalItem('prequalification', {
          public_key: publicKey,
          charges: charges
        });
      })
    }
  }, [charges]);
}

export default useBootstrapper;
